// extracted by mini-css-extract-plugin
export var bgColor = "topNav-module--bgColor--vD6Z6";
export var linkText = "topNav-module--linkText--xseJ3";